var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9017"
    },
    points: "406.372,386.154 429.522,185.677 82.478,185.677 105.628,386.154 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED7D0C"
    },
    points: "393.411,185.677 370.26,386.154 406.372,386.154 429.522,185.677 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "411.879,185.677 421.492,102.42 90.508,102.42 100.122,185.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "123.273,386.154 136.936,504.477 375.064,504.477 388.728,386.154  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C6C6"
    },
    points: "385.381,102.42 375.767,185.677 411.879,185.677 421.492,102.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6C6C6"
    },
    points: "352.617,386.154 338.953,504.477 375.064,504.477 388.728,386.154  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 69.985,
    y: 54.458,
    style: {
      fill: "#494949"
    },
    width: 372.027,
    height: 47.966
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#303030"
    },
    points: "421.492,54.455 90.508,54.455 118.365,7.523 393.635,7.523  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.874,
    y: 54.458,
    style: {
      fill: "#303030"
    },
    width: 45.139,
    height: 47.966
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#232323"
    },
    points: "393.635,7.523 348.496,7.523 376.353,54.455 421.492,54.455 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#7C3D1E"
    },
    cx: 256,
    cy: 282.321,
    rx: 43.283,
    ry: 52.713
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#602E18"
    },
    d: "M256,229.607c-4.732,0-9.281,0.938-13.542,2.646c17.268,6.925,29.738,26.716,29.738,50.065 c0,23.35-12.47,43.141-29.738,50.066c4.261,1.709,8.81,2.647,13.542,2.647c23.903,0,43.279-23.601,43.279-52.713 S279.903,229.607,256,229.607z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.016,46.932h-16.239L400.104,3.683C398.75,1.399,396.292,0,393.635,0H118.365c-2.655,0-5.114,1.399-6.469,3.683 l-25.67,43.248h-16.24c-4.155,0-7.523,3.368-7.523,7.523v47.966c0,4.155,3.368,7.523,7.523,7.523h13.818l7.876,68.209h-9.201 c-2.146,0-4.189,0.916-5.616,2.518c-1.427,1.602-2.103,3.737-1.858,5.868l23.15,200.477c0.438,3.796,3.653,6.661,7.474,6.661h10.939 l12.895,111.662c0.438,3.796,3.653,6.661,7.474,6.661h45.633c4.155,0,7.523-3.368,7.523-7.523s-3.368-7.523-7.523-7.523h-38.928 l-11.926-103.277h248.572l-11.926,103.277H212.661c-4.155,0-7.523,3.368-7.523,7.523s3.368,7.523,7.523,7.523h162.404 c3.821,0,7.036-2.864,7.473-6.661l12.894-111.662h10.939c3.822,0,7.036-2.864,7.473-6.661l23.15-200.477 c0.247-2.132-0.429-4.266-1.857-5.868c-1.428-1.602-3.472-2.518-5.617-2.518h-9.201l7.877-68.209h13.819 c4.156,0,7.523-3.368,7.523-7.523V54.455C449.539,50.3,446.171,46.932,442.016,46.932z M405.174,178.153h-43.316 c-4.156,0-7.523,3.368-7.523,7.523c0,4.155,3.367,7.523,7.523,7.523h59.221l0,0l-21.413,185.431l0,0H112.333l0,0L90.92,193.2l0,0 h240.846c4.156,0,7.523-3.368,7.523-7.523c0-4.155-3.367-7.523-7.523-7.523h-224.94l-7.876-68.209H413.05L405.174,178.153z  M434.492,94.897L434.492,94.897H77.509l0,0V61.978l0,0H137.1c4.155,0,7.523-3.368,7.523-7.523s-3.368-7.523-7.523-7.523h-33.379 l18.926-31.885h266.705l18.925,31.885H167.193c-4.155,0-7.523,3.368-7.523,7.523s3.368,7.523,7.523,7.523h267.298l0,0v32.919 H434.492z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.931,222.659c-0.324-0.074-0.651-0.117-0.98-0.148c-1.954-0.272-3.937-0.427-5.951-0.427 c-28.013,0-50.804,27.022-50.804,60.236c0,33.206,22.779,60.223,50.784,60.236c0.005,0,0.009,0.001,0.014,0.001 c0.004,0,0.008-0.001,0.012-0.001c28.01-0.004,50.798-27.023,50.798-60.236C306.804,251.895,287.676,226.681,262.931,222.659z  M220.244,282.32c0-21.036,11.433-38.761,26.859-43.772c-6.168,13.753-8.661,33.283,5.711,51.956 c10.493,13.634,3.252,29.858-0.73,36.729C234.203,324.758,220.244,305.563,220.244,282.32z M270.095,323.844 c0.328-0.924,0.646-1.867,0.939-2.846c4.44-14.833,2.261-28.55-6.297-39.67c-13.842-17.984-5.174-35.654-0.366-42.933 c15.69,4.776,27.386,22.653,27.386,43.926C291.757,300.914,282.822,316.916,270.095,323.844z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.3ef51ecee4443d9d21fbfb571f3f6956.svg";
export { ForwardRef as ReactComponent };